module.exports = __webpack_public_path__ + "img/header.065a9a91.png";